export const apiUrls = { RADAR_API_URL: 'https://radar.api.lootboy.de' };

export const setRadarApiUrl = (url) => {
  apiUrls.RADAR_API_URL = url;
};
